(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.__activityCarouselDefinition) {
      window.__activityCarouselDefinition = class ActivityCarousel {
        constructor(element) {
          this.element = element;
          this.viewport = element.querySelector('.activity-carousel__viewport');
          this.items = Array.from(element.querySelectorAll('.activity-carousel__item'));
          this.prevButton = element.querySelector('[data-action="prev"]');
          this.nextButton = element.querySelector('[data-action="next"]');
          this.dots = Array.from(element.querySelectorAll('.activity-carousel__dot'));
          this.currentIndex = 0;
          this.autoPlayTimer = null;
          this.dragStartX = 0;
          this.dragCurrentX = 0;
          this.isPointerDown = false;
          this.isDragging = false;
          this.autoPlayEnabled = element.dataset.autoplay === 'true' && this.items.length > 1;
          this.autoPlaySpeed = Number(element.dataset.autoplaySpeed) || 3000;

          if (element.dataset.initialized === 'true') return;
          element.dataset.initialized = 'true';

          this.update();
          this.bindEvents();
          this.startAutoPlay();
        }

        bindEvents() {
          this.prevButton?.addEventListener('click', () => this.prev());
          this.nextButton?.addEventListener('click', () => this.next());
          this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.goTo(index));
          });
          this.items.forEach((item) => {
            item.addEventListener('click', (event) => this.handleItemClick(event, item));
          });

          this.viewport?.addEventListener('mouseenter', () => this.stopAutoPlay());
          this.viewport?.addEventListener('mouseleave', () => {
            this.resetPointerState();
            this.startAutoPlay();
          });

          this.viewport?.addEventListener('touchstart', (event) => this.handleTouchStart(event), { passive: true });
          this.viewport?.addEventListener('touchmove', (event) => this.handleTouchMove(event), { passive: true });
          this.viewport?.addEventListener('touchend', () => this.handleTouchEnd());

          this.viewport?.addEventListener('mousedown', (event) => this.handleMouseDown(event));
          window.addEventListener('mousemove', (event) => this.handleMouseMove(event));
          window.addEventListener('mouseup', (event) => this.handleMouseUp(event));

          document.addEventListener('shopify:block:select', (event) => {
            const target = event.target.closest('.activity-carousel__item');
            if (!target || !this.element.contains(target)) return;

            const index = Number(target.dataset.index);
            if (Number.isNaN(index)) return;

            this.goTo(index);
            this.stopAutoPlay();
          });
        }

        handleTouchStart(event) {
          this.dragStartX = event.touches[0].clientX;
          this.dragCurrentX = this.dragStartX;
          this.isDragging = false;
          this.stopAutoPlay();
        }

        handleTouchMove(event) {
          this.dragCurrentX = event.touches[0].clientX;
          if (Math.abs(this.dragStartX - this.dragCurrentX) > 10) {
            this.isDragging = true;
          }
        }

        handleTouchEnd() {
          this.commitDrag();
          this.startAutoPlay();
        }

        handleMouseDown(event) {
          event.preventDefault();
          this.isPointerDown = true;
          this.dragStartX = event.clientX;
          this.dragCurrentX = this.dragStartX;
          this.isDragging = false;
          this.viewport?.classList.add('is-dragging');
          this.stopAutoPlay();
        }

        handleMouseMove(event) {
          if (!this.isPointerDown) return;
          this.dragCurrentX = event.clientX;
          if (Math.abs(this.dragStartX - this.dragCurrentX) > 10) {
            this.isDragging = true;
          }
        }

        handleMouseUp(event) {
          if (!this.isPointerDown) return;
          this.dragCurrentX = event.clientX;
          this.commitDrag();
          this.startAutoPlay();
        }

        handleItemClick(event, item) {
          if (this.isDragging) return;

          const interactiveTarget = event.target.closest('a, button');
          if (interactiveTarget && interactiveTarget !== item) return;

          const index = Number(item.dataset.index);
          if (Number.isNaN(index) || index === this.currentIndex) return;

          this.goTo(index);
          this.stopAutoPlay();
          this.startAutoPlay();
        }

        commitDrag() {
          const diff = this.dragStartX - this.dragCurrentX;
          const threshold = 50;

          if (Math.abs(diff) > threshold && this.isDragging) {
            if (diff > 0) {
              this.next();
            } else {
              this.prev();
            }
          }

          this.resetPointerState();
        }

        resetPointerState() {
          this.dragStartX = 0;
          this.dragCurrentX = 0;
          this.isPointerDown = false;
          this.isDragging = false;
          this.viewport?.classList.remove('is-dragging');
        }

        update() {
          const total = this.items.length;
          if (!total) return;

          this.items.forEach((item, index) => {
            item.classList.remove('is-active', 'is-prev', 'is-next', 'is-prev-2', 'is-next-2', 'is-hidden');

            let position = index - this.currentIndex;
            if (position > total / 2) position -= total;
            if (position < total / 2 * -1) position += total;

            if (position === 0) {
              item.classList.add('is-active');
            } else if (position === -1) {
              item.classList.add('is-prev');
            } else if (position === 1) {
              item.classList.add('is-next');
            } else if (position === -2) {
              item.classList.add('is-prev-2');
            } else if (position === 2) {
              item.classList.add('is-next-2');
            } else {
              item.classList.add('is-hidden');
            }
          });

          this.dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === this.currentIndex);
          });
        }

        next() {
          this.currentIndex = (this.currentIndex + 1) % this.items.length;
          this.update();
        }

        prev() {
          this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
          this.update();
        }

        goTo(index) {
          this.currentIndex = index;
          this.update();
        }

        startAutoPlay() {
          if (!this.autoPlayEnabled || this.autoPlayTimer) return;
          this.autoPlayTimer = window.setInterval(() => this.next(), this.autoPlaySpeed);
        }

        stopAutoPlay() {
          if (!this.autoPlayTimer) return;
          window.clearInterval(this.autoPlayTimer);
          this.autoPlayTimer = null;
        }
      };
    }

    if (!window.__initActivityCarousels) {
      window.__initActivityCarousels = (root = document) => {
        root.querySelectorAll('.js-activity-carousel').forEach((element) => {
          if (element.dataset.initialized === 'true') return;
          new window.__activityCarouselDefinition(element);
        });
      };

      document.addEventListener('DOMContentLoaded', () => window.__initActivityCarousels());
      document.addEventListener('shopify:section:load', (event) => window.__initActivityCarousels(event.target));
    }

    window.__initActivityCarousels();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tooto-about-snap-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
    const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
    const LOAD_SCROLL_LOCK_TIMEOUT = 1800;
    const LAST_SLIDE_SCROLL_RELEASE_DELAY = 500;
    const MOBILE_QUERY = '(max-width: 749px)';

    const lockScroll = (section) => {
      if (section.dataset.tootoAboutScrollLockOwner === 'true') return;
      if (document.documentElement.hasAttribute('scroll-lock')) return;

      section.dataset.tootoAboutScrollLockOwner = 'true';
      document.documentElement.setAttribute('scroll-lock', '');
    };

    const unlockScroll = (section) => {
      if (section.dataset.tootoAboutScrollLockOwner !== 'true') return;

      delete section.dataset.tootoAboutScrollLockOwner;
      document.documentElement.removeAttribute('scroll-lock');
    };

    const waitForFirstPanelMedia = (section) => {
      const firstPanel = section.querySelector('.tooto-about-snap-story__panel');
      const media = firstPanel?.querySelector('img, video');

      if (!media) return Promise.resolve();

      if (media instanceof HTMLImageElement) {
        if (media.complete && media.naturalWidth > 0) return Promise.resolve();

        return new Promise((resolve) => {
          media.addEventListener('load', resolve, { once: true });
          media.addEventListener('error', resolve, { once: true });
        });
      }

      if (media instanceof HTMLVideoElement) {
        if (media.readyState >= 2) return Promise.resolve();

        return new Promise((resolve) => {
          media.addEventListener('loadeddata', resolve, { once: true });
          media.addEventListener('error', resolve, { once: true });
        });
      }

      return Promise.resolve();
    };

    const loadSwiper = () => {
      if (window.Swiper) return Promise.resolve(window.Swiper);
      if (window.tootoSwiper8Promise) return window.tootoSwiper8Promise;

      window.tootoSwiper8Promise = new Promise((resolve, reject) => {
        if (!document.querySelector(`link[href="${SWIPER_CSS}"]`)) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = SWIPER_CSS;
          document.head.append(link);
        }

        const existing = document.querySelector(`script[src="${SWIPER_JS}"]`);
        if (existing) {
          existing.addEventListener('load', () => resolve(window.Swiper), { once: true });
          existing.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = SWIPER_JS;
        script.async = true;
        script.addEventListener('load', () => resolve(window.Swiper), { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.append(script);
      });

      return window.tootoSwiper8Promise;
    };

    const init = (section) => {
      if (!section || section.dataset.tootoAboutReady === 'true') return;
      lockScroll(section);

      const scroller = section.querySelector('[data-tooto-about-swiper]');
      const wrapper = scroller?.querySelector('.tooto-about-snap-story__wrapper');
      const videos = Array.from(section.querySelectorAll('video'));
      const mobileMediaQuery = window.matchMedia(MOBILE_QUERY);
      const mobileFooterPanel = wrapper?.querySelector('.tooto-about-snap-story__panel--mobile-footer');
      const isMobileFooterSlide = (panel) =>
        Boolean(panel && panel.classList.contains('tooto-about-snap-story__panel--mobile-footer'));
      const syncMobileFooterPanel = () => {
        if (!wrapper || !mobileFooterPanel) return;

        if (mobileMediaQuery.matches) {
          if (!wrapper.contains(mobileFooterPanel)) {
            wrapper.append(mobileFooterPanel);
          }
        } else if (wrapper.contains(mobileFooterPanel)) {
          wrapper.removeChild(mobileFooterPanel);
        }
      };

      syncMobileFooterPanel();
      const getPanels = () =>
        Array.from(section.querySelectorAll('.tooto-about-snap-story__panel')).filter(
          (panel) => getComputedStyle(panel).display !== 'none'
        );
      if (!scroller || !getPanels().length) {
        unlockScroll(section);
        return;
      }

      section.dataset.tootoAboutReady = 'true';
      const mediaReadyPromise = waitForFirstPanelMedia(section);
      let scrollUnlockTimer = window.setTimeout(() => unlockScroll(section), LOAD_SCROLL_LOCK_TIMEOUT);
      let lastSlideReleaseAt = 0;
      let lastSlideHoldScrollY = 0;
      let isRestoringLastSlideScroll = false;
      const releaseScrollLock = () => {
        window.clearTimeout(scrollUnlockTimer);
        scrollUnlockTimer = null;
        unlockScroll(section);
      };

      const updateActiveMedia = (activeIndex) => {
        const panels = getPanels();
        const activePanel = panels[activeIndex];

        if (section.tootoAboutSwiper) {
          const lockFooterScrollToPanel = mobileMediaQuery.matches && isMobileFooterSlide(activePanel);
          section.tootoAboutSwiper.allowTouchMove = !lockFooterScrollToPanel;
          if (section.tootoAboutSwiper.mousewheel) {
            if (lockFooterScrollToPanel) {
              section.tootoAboutSwiper.mousewheel.disable();
            } else {
              section.tootoAboutSwiper.mousewheel.enable();
            }
          }
        }

        videos.forEach((video) => {
          const isActive = activePanel?.contains(video);
          if (isActive) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      };

      const destroyExisting = () => {
        if (section.tootoAboutSwiper) {
          section.tootoAboutSwiper.destroy(true, true);
          section.tootoAboutSwiper = null;
        }
      };

      const shouldHoldLastSlideScroll = () => {
        const swiper = section.tootoAboutSwiper;
        const panels = getPanels();
        return Boolean(
          swiper &&
            !swiper.destroyed &&
            !window.matchMedia('(max-width: 749px)').matches &&
            swiper.activeIndex === panels.length - 1 &&
            performance.now() < lastSlideReleaseAt
        );
      };

      const restoreLastSlideScroll = () => {
        if (isRestoringLastSlideScroll || window.scrollY === lastSlideHoldScrollY) return;

        isRestoringLastSlideScroll = true;
        window.scrollTo({ top: lastSlideHoldScrollY, left: window.scrollX, behavior: 'instant' });
        window.requestAnimationFrame(() => {
          isRestoringLastSlideScroll = false;
        });
      };

      const holdLastSlideWheel = (event) => {
        if (event.deltaY <= 0 || !shouldHoldLastSlideScroll()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        restoreLastSlideScroll();
      };

      const holdLastSlideWindowScroll = () => {
        if (!shouldHoldLastSlideScroll()) return;
        restoreLastSlideScroll();
      };

      window.addEventListener('wheel', holdLastSlideWheel, { capture: true, passive: false });
      window.addEventListener('scroll', holdLastSlideWindowScroll, { passive: true });

      const initSwiper = (Swiper) => {
        if (!Swiper) {
          videos.forEach((video) => video.play().catch(() => {}));
          mediaReadyPromise.finally(releaseScrollLock);
          return;
        }

        destroyExisting();

        section.tootoAboutSwiper = new Swiper(scroller, {
          direction: 'vertical',
          effect: 'creative',
          slidesPerView: 1,
          speed: 720,
          nested: true,
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping',
          watchSlidesProgress: true,
          creativeEffect: {
            limitProgress: 2,
            prev: {
              translate: [0, 0, -1]
            },
            next: {
              translate: [0, '100%', 0]
            }
          },
          resistanceRatio: 0,
          followFinger: false,
          allowTouchMove: true,
          threshold: 8,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 0.95,
            thresholdDelta: 5
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          on: {
            init(swiper) {
              updateActiveMedia(swiper.activeIndex);
              mediaReadyPromise.finally(releaseScrollLock);
            },
            slideChange(swiper) {
              const panels = getPanels();
              if (swiper.activeIndex === panels.length - 1) {
                lastSlideHoldScrollY = window.scrollY;
                lastSlideReleaseAt = Number.POSITIVE_INFINITY;
              } else {
                lastSlideReleaseAt = 0;
              }
              updateActiveMedia(swiper.activeIndex);
            },
            slideChangeTransitionEnd(swiper) {
              const panels = getPanels();
              if (swiper.activeIndex === panels.length - 1) {
                window.scrollTo({ top: lastSlideHoldScrollY, left: window.scrollX, behavior: 'instant' });
                lastSlideReleaseAt = performance.now() + LAST_SLIDE_SCROLL_RELEASE_DELAY;
              }
            }
          }
        });
      };

      loadSwiper()
        .then(initSwiper)
        .catch(() => {
          videos.forEach((video) => video.play().catch(() => {}));
          return mediaReadyPromise.finally(releaseScrollLock);
        });

      const handleResize = () => {
        syncMobileFooterPanel();
        if (section.tootoAboutSwiper) {
          section.tootoAboutSwiper.update();
          updateActiveMedia(section.tootoAboutSwiper.activeIndex);
        }
      };

      window.addEventListener('resize', handleResize);
      if (mobileMediaQuery.addEventListener) {
        mobileMediaQuery.addEventListener('change', handleResize);
      } else if (mobileMediaQuery.addListener) {
        mobileMediaQuery.addListener(handleResize);
      }

      if (mobileFooterPanel) {
        const stopFooterScrollPropagation = (event) => {
          if (!mobileMediaQuery.matches) return;
          event.stopPropagation();
        };

        const blockSwiperCapture = (event) => {
          if (!mobileMediaQuery.matches) return;
          event.stopImmediatePropagation();
        };

        let footerTouchStartY = 0;
        let footerTouchStartScrollTop = 0;
        let footerTouchPrevY = 0;

        const getFooterMaxScrollTop = () =>
          Math.max(0, mobileFooterPanel.scrollHeight - mobileFooterPanel.clientHeight);

        const slideToPreviousPanel = () => {
          if (!section.tootoAboutSwiper) return;
          if (section.tootoAboutSwiper.animating) return;

          section.tootoAboutSwiper.allowTouchMove = true;
          if (section.tootoAboutSwiper.mousewheel) {
            section.tootoAboutSwiper.mousewheel.enable();
          }
          section.tootoAboutSwiper.slidePrev();
        };

        const syncFooterWheel = (event) => {
          if (!mobileMediaQuery.matches) return;
          event.preventDefault();
          event.stopPropagation();
          const currentScrollTop = mobileFooterPanel.scrollTop;
          const maxScrollTop = getFooterMaxScrollTop();
          const nextScrollTop = Math.min(maxScrollTop, Math.max(0, currentScrollTop + event.deltaY));
          const isAtTop = currentScrollTop <= 0;
          const isScrollingUp = event.deltaY < 0;

          if (isAtTop && isScrollingUp) {
            slideToPreviousPanel();
            return;
          }

          mobileFooterPanel.scrollTop = nextScrollTop;
        };

        const onFooterTouchStart = (event) => {
          if (!mobileMediaQuery.matches) return;
          footerTouchStartY = event.touches[0]?.clientY ?? 0;
          footerTouchPrevY = footerTouchStartY;
          footerTouchStartScrollTop = mobileFooterPanel.scrollTop;
        };

        const onFooterTouchMove = (event) => {
          if (!mobileMediaQuery.matches) return;
          const currentY = event.touches[0]?.clientY ?? footerTouchStartY;
          const totalDeltaY = footerTouchStartY - currentY;
          const stepDeltaY = footerTouchPrevY - currentY;
          const maxScrollTop = getFooterMaxScrollTop();
          const nextScrollTop = Math.min(
            maxScrollTop,
            Math.max(0, footerTouchStartScrollTop + totalDeltaY)
          );
          const isAtTop = mobileFooterPanel.scrollTop <= 0;
          const isSwipingDown = stepDeltaY < 0;

          if (isAtTop && isSwipingDown) {
            slideToPreviousPanel();
            footerTouchStartY = currentY;
            footerTouchPrevY = currentY;
            footerTouchStartScrollTop = mobileFooterPanel.scrollTop;
            return;
          }

          mobileFooterPanel.scrollTop = nextScrollTop;
          footerTouchPrevY = currentY;
          event.stopPropagation();
        };

        mobileFooterPanel.addEventListener('wheel', syncFooterWheel, { passive: false });
        mobileFooterPanel.addEventListener('wheel', stopFooterScrollPropagation, { passive: true });
        mobileFooterPanel.addEventListener('touchstart', onFooterTouchStart, { passive: true });
        mobileFooterPanel.addEventListener('touchmove', onFooterTouchMove, { passive: true });
        mobileFooterPanel.addEventListener('touchmove', stopFooterScrollPropagation, { passive: true });
        mobileFooterPanel.addEventListener('pointerdown', blockSwiperCapture, { capture: true });
        mobileFooterPanel.addEventListener('touchstart', blockSwiperCapture, { capture: true, passive: true });
        mobileFooterPanel.addEventListener('touchmove', blockSwiperCapture, { capture: true, passive: true });
      }
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-tooto-about-snap-story]').forEach(init);
    };

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tooto-bespoke-category-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.tooto-bespoke-category-card');
    if (!cards.length) return;

    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    const stagger = isMobile ? 80 : 160;

    cards.forEach((card, index) => {
      card.style.transitionDelay = `${index * stagger}ms`;
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: isMobile ? 0.15 : 0.1,
      rootMargin: isMobile ? '0px 0px 0px 0px' : '0px 0px -40px 0px',
    });

    cards.forEach(card => observer.observe(card));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tooto-bespoke-work-detail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.bespokeDetailInit === 'true') return;
      section.dataset.bespokeDetailInit = 'true';

      const slides = Array.from(section.querySelectorAll('[data-feature-slide]'));
      const prev = section.querySelector('[data-feature-prev]');
      const next = section.querySelector('[data-feature-next]');
      const revealTargets = Array.from(
        section.querySelectorAll(`
          .tooto-bespoke-work-detail__hero-copy,
          .tooto-bespoke-work-detail__hero-media,
          .tooto-bespoke-work-detail__feature,
          .tooto-bespoke-work-detail__editorial-inner,
          .tooto-bespoke-work-detail__gallery-item,
          .tooto-bespoke-work-detail__spec-media,
          .tooto-bespoke-work-detail__spec-copy,
          .tooto-bespoke-work-detail__product
        `)
      );

      if (revealTargets.length) {
        section.dataset.animationsReady = 'true';
        revealTargets.forEach((target, index) => {
          target.style.setProperty('--tbwd-reveal-delay', `${Math.min(index * 55, 220)}ms`);
        });

        if (!('IntersectionObserver' in window)) {
          revealTargets.forEach((target) => target.classList.add('is-revealed'));
        } else {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-revealed');
                observer.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
          );

          revealTargets.forEach((target) => observer.observe(target));
        }
      }

      if (slides.length < 2 || !prev || !next) return;

      let current = 0;
      const show = (index) => {
        current = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === current ? 'false' : 'true');
        });
      };

      prev.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
    };

    const initAll = (root = document) => {
      root.querySelectorAll('.tooto-bespoke-work-detail').forEach(init);
    };

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tooto-bespoke-work-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      if (!section || section.dataset.bespokeWorkInitialized === 'true') return;

      const viewport = section.querySelector('[data-bespoke-work-viewport]');
      const track = section.querySelector('[data-bespoke-work-track]');
      const prev = section.querySelector('[data-bespoke-work-prev]');
      const next = section.querySelector('[data-bespoke-work-next]');
      const cards = Array.from(section.querySelectorAll('[data-bespoke-work-card]'));

      section.dataset.bespokeWorkInitialized = 'true';
      section.classList.add('is-animation-ready');

      const revealAll = () => {
        cards.forEach((card, index) => {
          card.style.setProperty('--tbw-reveal-index', index);
          card.classList.add('is-revealed');
        });
      };

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window && viewport) {
        const inPage = new WeakSet();
        let pendingReveal = [];
        let revealQueued = false;

        const isInCarousel = (card) => {
          const viewportRect = viewport.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();

          return cardRect.right > viewportRect.left + 8 && cardRect.left < viewportRect.right - 8;
        };

        const flushReveal = () => {
          revealQueued = false;
          pendingReveal = pendingReveal
            .filter((card) => !card.classList.contains('is-revealed'))
            .sort((a, b) => a.offsetLeft - b.offsetLeft);

          pendingReveal.forEach((card, index) => {
            card.style.setProperty('--tbw-reveal-index', index);
            card.classList.add('is-revealed');
            pageObserver.unobserve(card);
          });

          pendingReveal = [];
        };

        const requestReveal = (card) => {
          if (card.classList.contains('is-revealed')) return;
          if (!inPage.has(card) || !isInCarousel(card)) return;
          if (!pendingReveal.includes(card)) pendingReveal.push(card);
          if (!revealQueued) {
            revealQueued = true;
            requestAnimationFrame(flushReveal);
          }
        };

        const checkCarouselVisibility = () => {
          cards.forEach(requestReveal);
        };

        const pageObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            inPage.add(entry.target);
            requestReveal(entry.target);
          });
        }, {
          threshold: 0.01,
          rootMargin: '0px',
        });

        cards.forEach((card) => {
          pageObserver.observe(card);
        });

        viewport.addEventListener('scroll', checkCarouselVisibility, { passive: true });
        window.addEventListener('resize', checkCarouselVisibility, { passive: true });
        requestAnimationFrame(checkCarouselVisibility);
      } else {
        revealAll();
      }

      if (!viewport || !track || !prev || !next || cards.length < 2) return;

      const getStep = () => {
        if (cards.length < 2) return cards[0]?.offsetWidth || 0;
        return cards[1].offsetLeft - cards[0].offsetLeft;
      };

      const updateNav = () => {
        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        const hasOverflow = maxScroll > 2;
        const atStart = viewport.scrollLeft <= 4;
        const atEnd = viewport.scrollLeft >= maxScroll - 4;

        prev.hidden = !hasOverflow || atStart;
        next.hidden = !hasOverflow || atEnd;
      };

      prev.addEventListener('click', () => {
        viewport.scrollTo({
          left: Math.max(viewport.scrollLeft - getStep(), 0),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });

      next.addEventListener('click', () => {
        const maxScroll = viewport.scrollWidth - viewport.clientWidth;

        viewport.scrollTo({
          left: Math.min(viewport.scrollLeft + getStep(), maxScroll),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });

      updateNav();
      viewport.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav, { passive: true });
    };

    const initAll = (root = document) => {
      root.querySelectorAll('.js-tooto-bespoke-work').forEach(initSection);
    };

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tooto-switching-series-cards"] && !Shopify.designMode) return;
  try {
    
  class TootoSwitchingSeries extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd);
      this.addEventListener('touchmove', this.handleTouchMove, { passive: false });
      this._setupRevealObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('touchstart', this.handleTouchStart);
      this.removeEventListener('touchend', this.handleTouchEnd);
      this.removeEventListener('touchmove', this.handleTouchMove);
      if (this._revealObserver) {
        this._revealObserver.disconnect();
      }
    }

    _setupRevealObserver() {
      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      this._revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            this._revealObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: isMobile ? 0.15 : 0.1,
        rootMargin: isMobile ? '0px 0px 0px 0px' : '0px 0px -40px 0px',
      });

      const cards = this.querySelectorAll('[data-tooto-series-card]');
      const stagger = isMobile ? 80 : 160;
      cards.forEach((card, index) => {
        card.style.transitionDelay = `${index * stagger}ms`;
        this._revealObserver.observe(card);
      });
    }

    handleTouchStart = (event) => {
      const touch = event.touches[0];
      this._touchStartX = touch.clientX;
      this._touchStartY = touch.clientY;
      this._touchHasMoved = false;
    };

    handleTouchMove = (event) => {
      if (this._touchStartX == null) return;
      const touch = event.touches[0];
      const dx = Math.abs(touch.clientX - this._touchStartX);
      const dy = Math.abs(touch.clientY - this._touchStartY);
      if (dx > dy && dx > 10) {
        event.preventDefault();
      }
      this._touchHasMoved = true;
    };

    handleTouchEnd = (event) => {
      if (this._touchStartX == null || !this._touchHasMoved) {
        this._touchStartX = null;
        this._touchStartY = null;
        return;
      }

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - this._touchStartX;
      const deltaY = touch.clientY - this._touchStartY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      if (absX > absY && absX > 50) {
        const card = event.target.closest('[data-tooto-series-card]');
        if (card) {
          const current = Number(card.dataset.activeIndex || 1);
          const direction = deltaX < 0 ? 1 : -1;
          const nextIndex = ((current - 1 + direction + 3) % 3) + 1;
          card.dataset.activeIndex = String(nextIndex);
          card.classList.toggle('tooto-switching-series-card--scene-active', nextIndex === 3);
        }
      }

      this._touchStartX = null;
      this._touchStartY = null;
    };

    handleClick = (event) => {
      const previous = event.target.closest('[data-tooto-series-previous]');
      const next = event.target.closest('[data-tooto-series-next]');
      if (!previous && !next) return;

      event.preventDefault();
      const card = event.target.closest('[data-tooto-series-card]');
      if (!card) return;

      const current = Number(card.dataset.activeIndex || 1);
      const direction = next ? 1 : -1;
      const nextIndex = ((current - 1 + direction + 3) % 3) + 1;
      card.dataset.activeIndex = String(nextIndex);
      card.classList.toggle('tooto-switching-series-card--scene-active', nextIndex === 3);
    };
  }

  if (!customElements.get('tooto-switching-series')) {
    customElements.define('tooto-switching-series', TootoSwitchingSeries);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tooto-three-image-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.tootoThreeImageReady === 'true') return;

      const slides = Array.from(section.querySelectorAll('[data-tooto-three-image-slide]'));
      if (slides.length < 2) return;

      section.dataset.tootoThreeImageReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      let activeIndex = 0;
      const interval = Number(section.style.getPropertyValue('--ttic-interval')) || 3000;
      const exitDuration = 1500;
      let exitTimer = null;

      const setActive = (index) => {
        if (index === activeIndex) return;

        if (exitTimer) {
          window.clearTimeout(exitTimer);
          exitTimer = null;
        }

        const previousSlide = slides[activeIndex];
        const nextSlide = slides[index];

        slides.forEach((slide) => {
          if (slide !== previousSlide) {
            slide.classList.remove('is-exiting');
          }
        });

        previousSlide.classList.remove('is-active');
        previousSlide.classList.add('is-exiting');
        previousSlide.setAttribute('aria-hidden', 'true');

        nextSlide.classList.remove('is-exiting');
        nextSlide.classList.add('is-active');
        nextSlide.setAttribute('aria-hidden', 'false');

        activeIndex = index;

        exitTimer = window.setTimeout(() => {
          previousSlide.classList.remove('is-exiting');
          exitTimer = null;
        }, exitDuration);
      };

      window.setInterval(() => {
        setActive((activeIndex + 1) % slides.length);
      }, interval);
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-tooto-three-image-carousel]').forEach(init);
    };

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tooto-triptych-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.triptychReady === 'true') return;

      const slides = Array.from(section.querySelectorAll('[data-triptych-slide]'));
      if (slides.length < 2) return;

      section.dataset.triptychReady = 'true';

      let activeIndex = 0;
      const interval = Number(section.style.getPropertyValue('--ttc-interval')) || 3000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion) return;

      const setActive = (index) => {
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      window.setInterval(() => {
        activeIndex = (activeIndex + 1) % slides.length;
        setActive(activeIndex);
      }, interval);
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-triptych-carousel]').forEach(init);
    };

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    initAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
